import { Clipboard, CurrencyDollar, Play, User } from '@phosphor-icons/react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useAppSelector } from '../../services/redux/store';

export function AppBar() {
  const userReducer = useAppSelector((state) => state.userReducer);
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <nav className="appBar plusHighlight">
      {userReducer.isLoggedIn ?
        <>
          <NavLink to="/" className="appBarIconContainer">
            <Play
              className="appBarIcon"
              weight={location.pathname === '/' ? 'fill' : 'regular'}
              color={location.pathname === '/' ? 'rgb(255,255,255)' : '#ffffff'}
            />
            <p>سفارش جاری</p>
          </NavLink>
          <NavLink to="/orders" className="appBarIconContainer">
            <Clipboard
              className="appBarIcon"
              weight={location.pathname === '/orders' ? 'fill' : 'regular'}
              color={location.pathname === '/orders' ? 'rgb(255,255,255)' : '#ffffff'}
            />
            <p>سفارش ها</p>
          </NavLink>
          <NavLink to="/bill" className="appBarIconContainer">
            <CurrencyDollar
              className="appBarIcon"
              weight={location.pathname === '/bill' ? 'fill' : 'regular'}
              color={location.pathname === '/bill' ? 'rgb(255,255,255)' : '#ffffff'}
            />
            <p>مالی</p>
          </NavLink>
          <NavLink
            to={'/profile'}
            className="appBarIconContainer"
          >
            <User
              className="appBarIcon"
              weight={location.pathname === '/profile' ? 'fill' : 'regular'}
              color={location.pathname === '/profile' ? 'rgb(255,255,255)' : '#ffffff'}
            />
            <p>پروفایل</p>
          </NavLink>
        </> :
        <NavLink
          to={'/login'}
          className="appBarIconContainer"
        >
          <User
            className="appBarIcon"
            weight={location.pathname === '/login' ? 'fill' : 'regular'}
            color={location.pathname === '/login' ? 'rgb(255,255,255)' : '#ffffff'}
          />
          <p>ورود</p>
        </NavLink>
      }
    </nav>
  );
}
